import React, { useEffect, useState } from "react";
import { Container, Header, Grid, Loader } from "semantic-ui-react";
import { CourseCard } from "../../../components/Student/MyCourses";
import { Course } from "../../../api";
import { useAuth } from "../../../hooks";
import "./MyCourses.scss";

const courseController = new Course();

export function MyCourses(props) {
  const { user, accessToken } = useAuth();
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoadingCourses(true);
        setCourses([]);
        const response = await courseController.getCoursesByStudent(
          accessToken,
          user.studentId
        );
        setCourses(response);
      } catch (error) {
        // Error handled silently
      } finally {
        setLoadingCourses(false);
      }
    })();
  }, [user, accessToken]);

  return (
    <div className="my-courses-page">
      <h1 className="my-courses__title">Mis Cursos</h1>
      <p className="my-courses__description">
        Aquí puedes ver todos tus cursos actuales, sus profesores y tu progreso
        en cada uno.
      </p>
      <Grid className="my-courses__list" stretched stackable columns={2}>
        {loadingCourses ? (
          <div className="my-courses__loader">
            <Loader active inline="centered" size="large" />
            <p>Cargando cursos...</p>
          </div>
        ) : (
          courses.map((course, index) => (
            <Grid.Column key={index}>
              <CourseCard course={course} />
            </Grid.Column>
          ))
        )}
      </Grid>
    </div>
  );
}
